<template>
  <app-modal name="view-tag-info" :esc-to-close="false" @before-open="beforeOpen" :title="title" width="65%"
    hide-footer>
    <app-form
      ref="form"
      :schema="schema"
      :data="formModel"
    />
  </app-modal>
</template>

<script>
import TagProxy from '@/store/proxies/tag-proxy';
import AppForm from '@/components/app-form/';
import AppModal from '@/components/app-modal/';
import { mapActions } from 'vuex';


export default {
  name: 'ViewTagInfo',
  components: {
    AppModal,
    AppForm,
  },

  data() {
    return {
      title: '',
      formErrors: '',
      formModel: {
        full_name: null,
        company_address: null,
        tax_code: null,
      },
      schema: [
        {
          name: 'full_name',
          label: this.$t('user.companyName'),
          type: 'input',
          disabled: true,
        },
        {
          name: 'company_address',
          label: this.$t('user.companyAddress'),
          type: 'input',
          disabled: true,
        },
        {
          name: 'tax_code',
          label: this.$t('user.taxCode'),
          type: 'input',
          disabled: true,
        },
      ],
    };
  },
  methods: {
    ...mapActions(['getTagAsGroup']),
    beforeOpen(params) {
      this.title = this.$t('app.customerInfo');
      this.formModel = params.model.company;
    },
    create() {
      this.$modal.show('view-tag-info', {
        model: {},
      });
    },
    refresh() {
      new TagProxy().getOwnerTagAccessList().then((response) => {
        this.accessList = response;
      });
      this.getTagAsGroup();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/tag/view-tag-info.vue